import { OWL_SVG, h, svg } from "replayowl/dashboard/util.ts";

const ERRORS: Record<string, string> = {
  cancelled: "Sign-in was cancelled.",
  state: "The sign-in took too long or was started in another tab. Try again.",
  provider: "The sign-in provider did not confirm who you are. Try again.",
};

document.getElementById("mark")!.append(svg(OWL_SVG.replace("<svg ", '<svg width="44" height="44" ')));
const params = new URLSearchParams(location.search);
const error = document.getElementById("error")!;
const code = params.get("error");
if (code) {
  error.textContent = ERRORS[code] || "Sign-in failed.";
  error.hidden = false;
}

const box = document.getElementById("providers")!;
const next = params.get("next") || "/app";
try {
  const res = await fetch("/api/providers");
  const { providers } = (await res.json()) as { providers: { id: string; name: string }[] };
  if (!providers.length) box.append(h("p", { class: "muted" }, "No sign-in method is configured."));
  for (const p of providers) {
    box.append(h("a", { class: "btn wide oauth-btn", href: "/auth/" + p.id + "?next=" + encodeURIComponent(next) }, "Continue with " + p.name));
  }
} catch {
  error.textContent = "Could not reach the server.";
  error.hidden = false;
}
